jQuery(document).ready(function ($) {
    const blocks = $('.posts-block');

    blocks.each((key, block) => {
        const swiper_element = $(block).find('.swiper').get(0);
        const prev = $(block).find('.swiper-button-prev').get(0);
        const next = $(block).find('.swiper-button-next').get(0);

        new Swiper(swiper_element, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: next,
                prevEl: prev
            },
            breakpoints: {
                1: {
                    slidesPerView: 'auto',
                    spaceBetween: 10
                },
                769: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                1025: {
                    slidesPerView: 4,
                    spaceBetween: 15
                },
                1301: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
            }
        });
    });
});
